import {TABLE_TYPE} from './BudgetUtils';
import {remapId} from '../../../../../forecast-app/shared/util/FinancialInternationalisationUtil';

const translationMap = {
	cost: 'project_budget.cost',
	actualCost: 'project_budget.cost',
	actualVsPlanCost: 'project_budget.cost',
	baselineCost: 'project_budget.cost',
	baselineVsActualCost: 'project_budget.cost',
	baselineVsForecastCost: 'project_budget.cost',
	plannedCost: 'project_budget.cost',
	forecastCost: 'project_budget.cost',
	forecastVsPlanCost: 'project_budget.cost',
	remainingCost: 'project_budget.cost',
	revenue: 'project_budget.revenue',
	actualRevenue: 'project_budget.revenue',
	baselineRevenue: 'project_budget.revenue',
	baselineVsActualRevenue: 'project_budget.revenue',
	baselineVsForecastRevenue: 'project_budget.revenue',
	plannedRevenue: 'project_budget.revenue',
	actualVsPlanRevenue: 'project_budget.revenue',
	forecastRevenue: 'project_budget.revenue',
	forecastVsPlanRevenue: 'project_budget.revenue',
	remainingRevenue: 'project_budget.revenue',
	profit: 'project_budget.profit',
	actualProfit: 'project_budget.profit',
	baselineProfit: 'project_budget.profit',
	baselineVsActualProfit: 'project_budget.profit',
	baselineVsForecastProfit: 'project_budget.profit',
	actualVsPlanProfit: 'project_budget.profit',
	plannedProfit: 'project_budget.profit',
	forecastProfit: 'project_budget.profit',
	forecastVsPlanProfit: 'project_budget.profit',
	remainingProfit: 'project_budget.profit',
	invoiced: 'project_budget.invoiced',
	invoicedVsActualRevenue: 'project_budget.accrued',
	retainerPeriodTargetMinutes: 'project_budget.retainer_period_target_minutes',
	retainerPeriodTargetPrice: 'project_budget.retainer_period_target_price',
	margin: 'project_budget.margin',
	paid: 'project_budget.paid',
	registeredMinutes: 'project_budget.time_entries',
	remainingMinutes: 'project_budget.remainingMinutes',
	forecastMinutes: 'project_budget.time_entries',
	allocatedMinutes: 'project_budget.plan',
	baselineMinutes: 'project_budget.time_entries',
	scopeApprovedMinutes: 'project_budget.estimated_scope',
	time: 'project_budget.time',
	baselineVsRegisteredMinutes: 'project_budget.time_entries',
	baselineVsForecastMinutes: 'project_budget.time_entries',
	registeredVsScopeApprovedMinutes: 'common.variance',
	forecastVsScopeApprovedMinutes: 'common.variance',
	billableTime: 'project_budget.billable_time_spent',
	billableTimeAccumulated: 'project_budget.billable_time_spent_accumulated',
	recognitionPercentage: 'project_budget.recognition_percentage',
	recognitionManualPercentage: 'project_budget.recognition_manual_percentage',
	expenseRevenuePercentage: 'project_budget.recognition_percentage',
	recognitionAmountRecognition: 'project_budget.recognition_amount.recognition_table',
	recognitionAmountTimeRecognition: 'project_budget.recognition_amount.recognition_time_table',
	recognitionAmountExpenseRecognition: 'project_budget.recognition_amount.recognition_expense_table',
	recognitionPercentageAccumulatedTimeRecognition: 'project_budget.recognition_percentage_accumulated.recognition_time_table',
	recognitionPercentageAccumulatedExpenseRecognition:
		'project_budget.recognition_percentage_accumulated.recognition_expense_table',
	recognitionAmountAccumulatedTimeRecognition:
		'project_budget.recognition_amount_accumulated.recognition_time_table.recognition_time_table',
	recognitionAmountAccumulatedExpenseRecognition:
		'project_budget.recognition_amount_accumulated.recognition_time_table.recognition_expense_table',
	surplus: 'project_budget.time_material_vs_recognition',
	surplusPercentage: 'project_budget.surplus_percentage',
	estimatedCostRecognition: 'project_budget.estimated_cost.recognition_table',
	estimatedCostTimeRecognition: 'project_budget.estimated_cost.recognition_time_table',
	estimatedCostExpenseRecognition: 'project_budget.estimated_cost.recognition_expense_table',
	estimatedCostPercentage: 'project_budget.estimated_cost_percentage.recognition_time_table',
	expenseCostPercentage: 'project_budget.estimated_cost_percentage.recognition_expense_table',
	estimatedCostAccumulatedTimeRecognition: 'project_budget.estimated_cost_accumulated.recognition_time_table',
	estimatedCostAccumulatedExpenseRecognition: 'project_budget.estimated_cost_accumulated.recognition_expense_table',
	estimatedCostPercentageAccumulated: 'project_budget.estimated_cost_percentage_accumulated.recognition_time_table',
	expenseCostPercentageAccumulated: 'project_budget.estimated_cost_percentage_accumulated.recognition_expense_table',
	recognitionProfit: 'project_budget.recognition_profit',
	recognitionProfitPercentage: 'project_budget.recognition_profit_percentage',
	expenses: 'project_budget.expenses',
	recognitionTotal: 'project_budget.recognition_amount',
	forecastProfitTimeRecognition: 'project_budget.recognition_profit',
	forecastMarginTimeRecognition: 'project_budget.recognition_profit_percentage',
};

const getTranslationId = (rowName, tableType) => {
	const rowsWithDifferentLabels = [
		'recognitionAmount',
		'recognitionAmountAccumulated',
		'recognitionPercentageAccumulated',
		'estimatedCost',
		'estimatedCostAccumulated',
		'forecastProfit',
		'forecastMargin',
	];
	let tableSuffix = '';
	if (rowsWithDifferentLabels.includes(rowName)) {
		switch (tableType) {
			case TABLE_TYPE.REVENUE_RECOGNITION:
				tableSuffix = 'Recognition';
				break;
			case TABLE_TYPE.TIME_REVENUE_RECOGNITION:
				tableSuffix = 'TimeRecognition';
				break;
			case TABLE_TYPE.EXPENSE_REVENUE_RECOGNITION:
				tableSuffix = 'ExpenseRecognition';
				break;
		}
	}
	return remapId(translationMap[rowName + tableSuffix]);
};

const getAggregateRowTitle = (intl, rowName, tableType) => {
	return rowName ? intl.formatMessage({id: getTranslationId(rowName, tableType) || rowName}) : '';
};

export default getAggregateRowTitle;
